const codeStorage = window.sessionStorage;
const codeKey = 'qommand-code-list';
export const isExistCode = (hashcode) => {
    if (!codeStorage)
        return false;
    return !!JSON.parse(codeStorage.getItem(codeKey) ?? '{}')[hashcode];
};
export const getCode = (hashcode) => {
    if (!codeStorage)
        return [];
    return JSON.parse(codeStorage.getItem(codeKey) ?? '{}')[hashcode];
};
export const setCode = (hashcode, data) => {
    if (!codeStorage)
        return;
    const codeData = JSON.parse(codeStorage.getItem(codeKey) ?? '{}');
    codeData[hashcode] = data;
    codeStorage.setItem(codeKey, JSON.stringify(codeData));
};
